import React, { FC, useCallback, useEffect } from 'react';

import styles from './Step.module.css';
import cls from 'classnames';
import { useState } from '../../../state/store';
import { StepType } from '../../../state/types';
import Button from '../../Button/Button';

interface StepProps {
  stepToShow: StepType;
  stepBack?: StepType;
  stepNext?: StepType;
  isValid?: boolean;
}

const Step: FC<StepProps> = ({ children, stepToShow, stepBack, stepNext, isValid }) => {
  const { step, dispatch } = useState('step');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [step]);

  const back = useCallback(() => dispatch('step', stepBack), [dispatch, stepBack]);
  const next = useCallback(() => dispatch('step', stepNext), [dispatch, stepNext]);

  if (step !== stepToShow) {
    return null;
  }

  const isLastStep = step === StepType.Confirmation;

  return (
    <div className={cls(styles.Step, 'flex flex-col justify-center')} data-testid="Step">
      <div className="flex justify-center px-0 pt-8">{children}</div>
      {!isLastStep && (
        <div className="flex justify-center p-8">
          {stepBack && (
            <span className="px-2">
              <Button onClick={back}>Back</Button>
            </span>
          )}
          {stepNext && (
            <span className="px-2">
              <Button disabled={!isValid} onClick={next}>
                Next
              </Button>
            </span>
          )}
        </div>
      )}
    </div>
  );
};

export default Step;
